import { queryKey } from 'Shared/const/queryKey';
import type { GetPendingPointScheduleResponse } from 'viewup-api/v2';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';
import type { ViewingMoneyQueryKey } from './queries';

export const useGetPendingPointSchedule = (
  params?: QueryParam<
    GetPendingPointScheduleResponse,
    unknown,
    GetPendingPointScheduleResponse,
    ViewingMoneyQueryKey['pendingPointSchedule']['queryKey']
  >,
) => {
  const queryResult = useSDQuery<
    GetPendingPointScheduleResponse,
    unknown,
    GetPendingPointScheduleResponse,
    ViewingMoneyQueryKey['pendingPointSchedule']['queryKey']
  >({
    ...params?.options,
    ...queryKey.viewingMoney.pendingPointSchedule,
  });

  return queryResult;
};
